import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { CartProvider } from './context/CartContext';
import Layout from './components/layout/Layout';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import JewelleryPage from './pages/JewelleryPage';
import StylePage from './pages/StylePage';
import CollectionsPage from './pages/CollectionsPage';
import ContactPage from './pages/ContactPage';
import ProductDetailPage from './pages/ProductDetailPage';
import './App.css';

function App() {
  return (
    <HelmetProvider>
      <CartProvider>
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/jewellery" element={<JewelleryPage />} />
              <Route path="/style" element={<StylePage />} />
              <Route path="/collections" element={<CollectionsPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/product/:handle" element={<ProductDetailPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </CartProvider>
    </HelmetProvider>
  );
}

export default App;
